export default __webpack_public_path__ + "static/media/log.2b132072.svg";